import LoadingScreen from "../../components/_module/loading";
const LoadingPage = () => {
	return (
		<div>
			<LoadingScreen />
		</div>
	);
};

export default LoadingPage;
